import { PRODUCTVARIANTCOLORS } from "../actions";

const initialState = {
  productOptionPayloads: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case PRODUCTVARIANTCOLORS.SUCCESS:
      const payloadObject = action.response.request_payload,
        // Convert product variant id to a string to match it in the saga
        idString = payloadObject["product_variant_id"].toString();

      payloadObject["product_variant_id"] = idString;

      return {
        ...state,
        productOptionPayloads: [
          ...state.productOptionPayloads,
          { payload: payloadObject, response: action.response },
        ],
      };

    default:
      return state;
  }
}
